import React from 'react'
import { useTranslation } from 'react-i18next'
import './footer.css'

const Footer = () => {
  const { t } = useTranslation()
  // A string, so the year is never formatted as a number (2,026).
  const currentYear = String(new Date().getFullYear())

  return (
    <>
      <div className='footer-new-wrapper'>
        <div className='footer-new-content'>
          <p className='footer-copy-right-text'>{t('footer.copyright', { year: currentYear })}</p>
        </div>
      </div>
    </>
  )
}

export default Footer
